import React from 'react'

import { TableCell } from '@material-ui/core'

import { MyRowProps } from '../../types/tableTypes'
import { MoySkladOrderModel } from '../../server/mpsklad_core/Models/Orders/MoySkladOrderModel'

export const MoySkladWbIdCell =
  ({row}: MyRowProps<MoySkladOrderModel>) =>
    <TableCell className="table-border">
      {row.wbOrderExternalId ?? null}
      <br/>
      {row.wbOrderId ? `(${row.wbOrderId})` : null}
    </TableCell>